import { StarbucksConcept } from './starbucks_concept.js';

export function name(concept: StarbucksConcept): string {
  switch (concept) {
    case StarbucksConcept.Airport:
      return 'Airport';
    case StarbucksConcept.Grocery:
      return 'Grocery';
    case StarbucksConcept.College:
      return 'College';
  }
}
